import { Paragraph, View } from 'tamagui'
import { Button } from '@/src/common/components/Button'

export function MortgageUploadPending({ isUpdate }: { isUpdate: boolean }) {
  return (
    <>
      <Paragraph>
        Mesa must verify your mortgage statement before your{isUpdate ? ' updated' : ''} mortgage
        rewards become active.
      </Paragraph>
      <View mt={16}>
        <Button title="Pending Verification" disabled />
      </View>
    </>
  )
}
